<template>
  <section class="pubgm-mask-wrapper" v-if="show && isInPubgmGameApp">
    <img
      class="pubgm-hs-mask"
      v-lazy="require(`@/assets/images/detail/pubgm/pubgm-hs-mask.jpg`)"
      alt="pubgm-hs-mask"
    />
  </section>
</template>
<script>
  import { mapState, mapMutations } from 'vuex'
  import { isInPubgmGame } from '@/utils/pubgm'

  export default {
    data() {
      return {
        isInPubgmGameApp: false,
        count: 0,
      }
    },
    computed: {
      ...mapState(['gameName', 'region', 'source']),
      show() {
        const { gameName, region, source } = this
        return (
          gameName === 'pubgm' && region === 'ru' && source === 'pubgm-game'
        )
      },
    },
    mounted() {
      if (this.show) {
        const timeid = setInterval(() => {
          const flag = isInPubgmGame()
          this.count = this.count + 1
          this.isInPubgmGameApp = flag
          this.setInPubgmAPPState(flag)
          if (flag) {
            clearInterval(timeid)
          }
          if (this.count > 30) {
            clearInterval(timeid)
          }
        }, 300)
      }
    },
    methods: {
      ...mapMutations(['setInPubgmAPPState']),
    },
  }
</script>
<style lang="scss" scoped>
  .pubgm-mask-wrapper {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    .pubgm-hs-mask {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
</style>
